import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {DigitalSignEventsService} from '@shared/components/core-sign/services/digital-sign-events.service';
import {DigitalSignClause, DigitalSignClauses} from '../../../../../../../digital-sign/models/digital-sign-clauses';
import {DigitalSignOperatorStartedProcess, DigitalSignProcessDocument, DigitalSignSimpleClauseModel} from '@shared/components/core-sign/models/digital-signer.model';
import {SignersType} from '@shared/components/core-sign/models/enums.model';
import {Subscription} from 'rxjs';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component({
	selector: 'amd-digital-sign-customer-procedure-end',
	templateUrl: './digital-sign-customer-procedure-end.component.html',
	styleUrls: ['./digital-sign-customer-procedure-end.component.scss']
})
export class DigitalSignCustomerProcedureEndComponent implements OnInit, OnChanges, OnDestroy {

	@Input() customerToken: string;
	@Input() dsStartedProcess: DigitalSignOperatorStartedProcess;

	contentDialogResponseSubscription: Subscription;
	isAllChecked: boolean = false;
	translateContext = TranslateContext;

	constructor(
		private digitalSignEventsService: DigitalSignEventsService
	) {
	}

	ngOnInit(): void {
		this.contentDialogResponseSubscription =
			this.digitalSignEventsService.contentDialogResponseObservable.subscribe(
				response => {
					this.dsStartedProcess.documents[response.index].simpleClauses = response.simpleClauses;
					this.isAllChecked = this.isAllCheckedMethod();
				}
			);
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (!!changes.customerToken) {
			this.customerToken = changes.customerToken.currentValue;
		}
		if (!!changes.customerSignedDocuments) {
			this.dsStartedProcess = changes.customerSignedDocuments.currentValue;
		}
		if (!!this.customerToken && !!this.dsStartedProcess) {
			this.dsStartedProcess.documents = this.dsStartedProcess.documents.reverse();
		}
	}

	ngOnDestroy(): void {
		if (!!this.contentDialogResponseSubscription) {
			this.contentDialogResponseSubscription.unsubscribe();
		}
	}

	isAllCheckedMethod(): boolean {
		for (let i: number = 0; i < this.dsStartedProcess.documents.length; i++) {
			const digitalSignProcessDocument: DigitalSignProcessDocument = this.dsStartedProcess.documents[i];
			digitalSignProcessDocument.setIsAllChecked();
			if (!digitalSignProcessDocument.isAllChecked) {
				return false;
			}
		}
		return true;
	}

	openContentElement(index: number, dialogTitle: string, url: string, simpleClauses: any): void {
		this.digitalSignEventsService.openContentElementDialogSubject.next(
			{
				signer_type: SignersType.CUSTOMER,
				y: 0,
				token: this.customerToken,
				index: index,
				simpleClauses: simpleClauses,
				url: url,
				dialogTitle: dialogTitle,
				actionsAlignment: 'center'
			}
		);
	}

	openOperatorOPTDialog(): void {
		this.digitalSignEventsService.openCustomerOtpDialogSubject.next({documents_singed: this.getAcceptedClauses()});
	}

	private getAcceptedClauses(): any {
		const result: DigitalSignClauses[] = [];
		for (let i: number = 0; i < this.dsStartedProcess.documents.length; i++) {
			const digitalSignProcessDocument: DigitalSignProcessDocument = this.dsStartedProcess.documents[i];
			const clauses: DigitalSignClauses = new DigitalSignClauses(digitalSignProcessDocument.id);
			for (let j: number = 0; j < digitalSignProcessDocument.simpleClauses.length; j++) {
				const simpleClause: DigitalSignSimpleClauseModel = digitalSignProcessDocument.simpleClauses[j];
				clauses.addClause(new DigitalSignClause(simpleClause.id, !simpleClause.values.includes(false)));
			}
			result.push(clauses);
		}
		return result;
	}

	abortProcedure(): void {
		this.digitalSignEventsService.abortCustomerProcedureSubject.next();
	}
}
